const emptyStats = {
    range: 0,
    damage: 0,
    fireRate: 0,
    splashRadius: 0,
    slowFactor: 1,
    slowDuration: 0,
    poisonDps: 0,
    poisonDuration: 0,
    canTargetAir: false,
    canTargetGround: true,
    armorPiercing: 0,
};
export const TOWER_DEFINITIONS = {
    archer: {
        type: "archer",
        displayName: "Archer",
        description: "Fast single-target tower, balanced damage and rate.",
        baseCost: 50,
        baseStats: {
            ...emptyStats,
            range: 3.5,
            damage: 8,
            fireRate: 1.4,
            canTargetAir: true,
        },
        upgradeCosts: [60, 110, 200, 360],
        upgradeDamageMultiplier: [1.4, 1.4, 1.5, 1.6],
        upgradeRangeMultiplier: [1.1, 1.1, 1.15, 1.2],
        upgradeFireRateMultiplier: [1.1, 1.1, 1.15, 1.2],
        generatesIncome: 0,
    },
    cannon: {
        type: "cannon",
        displayName: "Cannon",
        description: "Slow high damage with AoE splash, ground only.",
        baseCost: 110,
        baseStats: {
            ...emptyStats,
            range: 3.0,
            damage: 30,
            fireRate: 0.5,
            splashRadius: 1.2,
        },
        upgradeCosts: [120, 220, 420, 760],
        upgradeDamageMultiplier: [1.5, 1.5, 1.6, 1.7],
        upgradeRangeMultiplier: [1.05, 1.1, 1.1, 1.15],
        upgradeFireRateMultiplier: [1.1, 1.15, 1.2, 1.25],
        generatesIncome: 0,
    },
    frost: {
        type: "frost",
        displayName: "Frost",
        description: "Slows mobs in range, low damage.",
        baseCost: 90,
        baseStats: {
            ...emptyStats,
            range: 2.8,
            damage: 3,
            fireRate: 1.2,
            slowFactor: 0.5,
            slowDuration: 1.5,
            canTargetAir: true,
        },
        upgradeCosts: [100, 180, 320, 580],
        upgradeDamageMultiplier: [1.3, 1.3, 1.4, 1.5],
        upgradeRangeMultiplier: [1.1, 1.15, 1.2, 1.25],
        upgradeFireRateMultiplier: [1.1, 1.1, 1.15, 1.2],
        generatesIncome: 0,
    },
    lightning: {
        type: "lightning",
        displayName: "Lightning",
        description: "Chains damage between nearby mobs.",
        baseCost: 140,
        baseStats: {
            ...emptyStats,
            range: 3.2,
            damage: 14,
            fireRate: 0.9,
            splashRadius: 2.5,
            canTargetAir: true,
        },
        upgradeCosts: [150, 280, 520, 920],
        upgradeDamageMultiplier: [1.4, 1.5, 1.6, 1.7],
        upgradeRangeMultiplier: [1.1, 1.1, 1.15, 1.2],
        upgradeFireRateMultiplier: [1.1, 1.15, 1.2, 1.25],
        generatesIncome: 0,
    },
    poison: {
        type: "poison",
        displayName: "Poison",
        description: "Applies damage-over-time on hit.",
        baseCost: 100,
        baseStats: {
            ...emptyStats,
            range: 3.0,
            damage: 4,
            fireRate: 1.0,
            poisonDps: 6,
            poisonDuration: 3,
        },
        upgradeCosts: [110, 200, 360, 640],
        upgradeDamageMultiplier: [1.3, 1.4, 1.5, 1.6],
        upgradeRangeMultiplier: [1.1, 1.1, 1.15, 1.2],
        upgradeFireRateMultiplier: [1.1, 1.15, 1.2, 1.25],
        generatesIncome: 0,
    },
    support: {
        type: "support",
        displayName: "Support",
        description: "Buffs nearby towers (damage and range).",
        baseCost: 130,
        baseStats: {
            ...emptyStats,
            range: 2.5,
            damage: 0,
            fireRate: 0,
        },
        upgradeCosts: [140, 260, 480, 860],
        upgradeDamageMultiplier: [1, 1, 1, 1],
        upgradeRangeMultiplier: [1.15, 1.2, 1.25, 1.3],
        upgradeFireRateMultiplier: [1, 1, 1, 1],
        generatesIncome: 0,
    },
    antiair: {
        type: "antiair",
        displayName: "Anti-Air",
        description: "Specialized vs flying mobs, ineffective on ground.",
        baseCost: 80,
        baseStats: {
            ...emptyStats,
            range: 4.0,
            damage: 12,
            fireRate: 1.5,
            canTargetAir: true,
            canTargetGround: false,
        },
        upgradeCosts: [90, 160, 290, 520],
        upgradeDamageMultiplier: [1.4, 1.5, 1.6, 1.7],
        upgradeRangeMultiplier: [1.1, 1.15, 1.2, 1.25],
        upgradeFireRateMultiplier: [1.1, 1.15, 1.2, 1.25],
        generatesIncome: 0,
    },
    economy: {
        type: "economy",
        displayName: "Sat Mine",
        description: "Generates passive sats over time, no attack.",
        baseCost: 120,
        baseStats: {
            ...emptyStats,
            range: 0,
            damage: 0,
            fireRate: 0,
        },
        upgradeCosts: [120, 240, 480, 960],
        upgradeDamageMultiplier: [1, 1, 1, 1],
        upgradeRangeMultiplier: [1, 1, 1, 1],
        upgradeFireRateMultiplier: [1, 1, 1, 1],
        generatesIncome: 2,
    },
};
export const BASE_LOADOUT = [
    "archer",
    "cannon",
    "frost",
    "lightning",
    "poison",
    "support",
    "antiair",
    "economy",
];
export function getTowerDefinition(type) {
    return TOWER_DEFINITIONS[type];
}
//# sourceMappingURL=towers.js.map